import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import EditButtonLink from 'Components/Blueprint/UI/EditButtonLink';

const AccountsTable = (props) => {
  const {
    children, className, subtitle, editLink, editTooltip,
  } = props;

  return (
    <table className={`accounts ${className}`}>
      <tbody>
        {subtitle !== '' && (
          <tr>
            <td colSpan="10">
              <h4 className="bordered">
                {subtitle}
                {editLink && (<EditButtonLink
                  title={editTooltip}
                  to={editLink}
                />)}
              </h4>
            </td>
          </tr>
        )}
        {children}
      </tbody>
    </table>
  );
};

AccountsTable.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  subtitle: PropTypes.string,
  editLink: PropTypes.string,
  editTooltip: PropTypes.string,
};

AccountsTable.defaultProps = {
  children: <Fragment />,
  className: '',
  subtitle: '',
  editLink: '',
  editTooltip: '',
};

export default AccountsTable;
